var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import styled from "styled-components";
import "rc-tooltip/assets/bootstrap_white.css";
import { color } from "../templates/ui";
import MandatoryIndicator from "./MandatoryIndicator";
import QuestionMark from "./icons/QuestionMark";
import Tooltip from "rc-tooltip";
import _ from "lodash";
import { getAppThemeName } from "../../Services/appTheme";
const Label = styled.label `
    display: inline-block;
    font-weight: ${(props) => (props.appTheme === "invoned" ? 500 : 600)};
    color: ${(props) => props.theme.textDark};
    margin-bottom: 10px;
    font-size: 15px;
`;
const Trigger = styled.div `
    transition: background-color 0.2s ease-in-out;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
    width: 22px;
    height: 22px;
    background-color: ${color.quinary.base};
    border-radius: 50%;
    cursor: pointer;

    &:hover,
    &:focus {
        background-color: ${color.quinary.hover};
    }
`;
const StyledQuestionMark = styled(QuestionMark) `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    fill: ${color.tertiary.base};
    width: 7px;
    height: auto;
`;
const InputLabel = (_a) => {
    var { children, tooltipContents, isMandatory } = _a, props = __rest(_a, ["children", "tooltipContents", "isMandatory"]);
    const [tooltipId] = useState(_.uniqueId("tooltip-"));
    return (React.createElement("div", { id: tooltipId },
        React.createElement(Label, Object.assign({ appTheme: getAppThemeName() }, props),
            children,
            isMandatory && React.createElement(MandatoryIndicator, null),
            tooltipContents && (React.createElement(Tooltip, { placement: "bottom", trigger: ["click"], overlay: tooltipContents, getTooltipContainer: () => document.getElementById(tooltipId) || document.body },
                React.createElement(Trigger, null,
                    React.createElement(StyledQuestionMark, null)))))));
};
export default InputLabel;
